/* eslint-disable camelcase */
'use strict';

const I18N = {
  general: {
    systemError: 'Det har oppstått en feil, vennligst prøv igjen eller kontakt <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a>',
    saved: 'Endringene er nå lagret'
  },
  datepicker: {
    previousMonth: 'Forrige måned',
    nextMonth: 'Neste måned',
    months: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
    weekdays: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
    weekdaysShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør']
  },
  overview: {
    categories: {
      draft: 'Halvferdig',
      paid: 'Regninger som er betalt',
      sent: 'Sendt til mottager',
      lost: 'Tapt fordring (du mottar ikke pengene)',
      dueDecide: 'Forfalt - beslutning kreves',
      dueSr: 'Forfalt - påminnelse kommer om kort tid',
      dunnedNotDue: 'Purret - purring ikke forfalt',
      collection: 'Innkreving/Inkasso',
      collectionDue: 'Forfalt inkassovarsel'
    }
  },
  payments: {
    alreadyPaid: 'Denne regningen er allerede merket som betalt. Er du sikker på at du vil registere en innbetaling til?',
    overpay: 'Beløpet på betalingen er større enn utestående, er du sikker på at dette er riktig?',
    error: {
      date: 'Dato og beløp er påkrevd',
      amount: 'Verdien må være større enn 0'
    }
  },
  user: {
    password: 'Hvis e-postadressen du oppga finnes i vårt system, har vi sendt deg en e-post med en lenke du må trykke på for å endre passord. Lenken er gyldig i en time. Hvis du ikke har mottatt e-posten innen 10 minutter, vennligst sjekk din søppelpostmappe. Hvis e-posten ikke finnes der, ta kontakt med oss på <a href="hjelp@sendregning.no">hjelp@sendregning.no</a>.',
    saved: 'Endringene for din SendRegning-konto er nå lagret',
    error: {
      login: 'Brukernavnet eller passordet ditt er feil',
      accountDeleted: 'Denne kontoen er deaktivert. Kontakt hjelp@sendregning.no',
      loginWithMFA: 'Bekreftelseskode, brukernavnet eller passordet ditt er feil',
      sameEmail: 'Du må endre e-postadresse'
    }
  },
  originator: {
    noAccess: 'Du har ikke tilgang til noen aktiv SendRegning-konto.'
  },
  recipient: {
    deleted: 'Denne kunden er slettet.',
    lost: 'Advarsel: Tidligere regninger til denne kunden er merket som tapt. Det anbefales å kreve forhåndsbetaling.'
  },
  offer: {
    error: {
      load: 'Kunne ikke laste tilbudet',
      save: 'Kunne ikke lagre tilbudet',
      noRecipient: 'Du må velge en kunde',
      noPrice: 'Kan ikke sende tilbud på kr 0,00',
      noDescription: 'Beskrivelsen av tilbudet er for lang',
      pastExpiryDate: 'Gyldig til-dato er i fortiden, trykk <b>Lagre, skriv ut og send</b> knappen igjen for å sende tilbudet allikevel.',
      pastDeliveryDate: 'Leveringsdato er i fortiden, trykk <b>Lagre, skriv ut og send</b> knappen igjen for å sende tilbudet allikevel.'
    }
  },
  orderConfirmation: {
    error: {
      load: 'Kunne ikke laste ordrebekreftelsen',
      save: 'Kunne ikke lagre ordrebekreftelsen',
      noRecipient: 'Du må velge en kunde',
      noPrice: 'Kan ikke sende ordrebekreftelse på kr 0,00',
      noDescription: 'Beskrivelsen av ordrebekreftelsen er for lang',
      pastDeliveryDate: 'Leveringsdato er i fortiden, trykk <b>Lagre, skriv ut og send</b> knappen igjen for å sende ordrebekreftelsen allikevel.'
    }
  },
  event: {
    error: {
      download: 'Kunne ikke laste arrangement',
      pastDate: 'Dato for arrangementet kan ikke være i fortiden',
      pastRegistrationDate: 'Tidspunktet for arrangementet kan ikke være i fortiden',
      pastEndDate: '"Varer til" kan ikke være etter tidspunktet for arrangementet',
      beforeDate: 'Påmeldingsfrist kan ikke være etter tidspunktet for arrangementet'
    }
  },
  participant: {
    notFound: 'Fant ikke deltager',
    smsSent: 'Meldingene er sendt'
  },
  dunning: {
    sent: 'Purringene er sendt',
    text: 'Vi kan dessverre ikke se å ha mottatt deres betaling for denne regningen.',
    error: {
      noSelection: 'Du må velge minst en faktura å sende purring for'
    }
  },
  massCredit: {
    sent: 'Kreditnoter er sendt',
    error: {
      noSelection: 'Du må velge minst en faktura å sende kreditnoter for',
      someFailed: 'Noen fakturaer ble ikke kreditert. Kontakt kundestøtte for mer informasjon'
    }
  },
  fields: {
    organisation_number: 'Organisasjonsnummer'
  }
};

angular
  .module('SendRegning')
  .constant('I18N', I18N);
